import React from 'react';
import { Box, Flex } from '@chakra-ui/react';
import dynamic from 'next/dynamic';

const Waveform = dynamic(() => import('components/Waveform'), { ssr: false });

const AudioNft = ({ file, has_unlockables, noControls, imageSize, ...props }) => {
  // console.log('file', file);
  return (
    <Flex w={{ base: '100%', md: '400px' }} id="image" mr="40px" flexDirection="column" {...props}>
      <Flex id="player" w="100%" mt={noControls ? 0 : '10px'}>
        <Box w="100%">
          <Waveform 
            has_unlockables={has_unlockables} 
            url={file} 
            noControls
            imageSize={imageSize}
          />
        </Box>
      </Flex>
    </Flex>
  );
};
export default AudioNft;
